exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@media (max-width:37.4rem){.style_hide-sm__12oKq{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__2Rcor{display:none!important}}@media (max-width:79.9rem){.style_hide-md__361fe{display:none!important}}@media (min-width:79.9rem){.style_visible-md__2Sczv{display:none!important}}h1{font-size:1.625rem;font-weight:400}@media (max-width:37.4rem){h1{font-size:1.4375rem}}h2{font-size:1.25rem;font-weight:400}@media (max-width:37.4rem){h2{font-size:1.0625rem}}h3{font-size:1.125rem;font-weight:400}@media (max-width:37.4rem){h3{font-size:1.0625rem}}h4{font-size:1.0625rem;font-weight:500;margin:1rem 0 .5rem}h5{font-size:.8125rem;font-weight:400}hr{display:block;height:.0625rem;border:0;border-top:.0625rem solid #ccc;margin:1em 0;padding:0}a{color:#2f93e0}a:hover{color:#0a67b1}p{margin:1rem 0;color:#333}input:-webkit-autofill{-webkit-box-shadow:0 0 0 1000px #fff inset!important}input::-ms-clear{width:0;height:0}small{font-size:.875rem;line-height:1.1875rem}.style_secondary__OlUSy{color:#9e9e9e}.style_section__2Jp-W{flex-grow:1}.style_sectionHeader__1WJUP{padding:0 1rem;margin:1rem 0 .5rem}.style_sectionBody__2cABV{padding:0 1rem;color:#666;font-size:.875rem}.style_sectionBody__2cABV p{color:#333}.style_sectionNoHeader__2GCHR{margin:1rem 0 .5rem;width:100%}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__12oKq",
	"hideSm": "style_hide-sm__12oKq",
	"visible-sm": "style_visible-sm__2Rcor",
	"visibleSm": "style_visible-sm__2Rcor",
	"hide-md": "style_hide-md__361fe",
	"hideMd": "style_hide-md__361fe",
	"visible-md": "style_visible-md__2Sczv",
	"visibleMd": "style_visible-md__2Sczv",
	"secondary": "style_secondary__OlUSy",
	"section": "style_section__2Jp-W",
	"sectionHeader": "style_sectionHeader__1WJUP",
	"sectionBody": "style_sectionBody__2cABV",
	"sectionNoHeader": "style_sectionNoHeader__2GCHR"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/Section/style.less
// module id = 1658
// module chunks = 8